module.exports = "<button color=\"primary\" md-raised-button *ngIf=\"!shareArtist && !song && !playlist\" (click)=\"openDialog($event)\">Invite</button>\n<button md-button class=\"wg-icon\" *ngIf=\"shareArtist || song || playlist\" mdTooltip=\"{{ 'Share' | tooltip }}\" color='primary'\n        (click)=\"openDialog($event)\">\n  <i class=\"material-icons icon add-to-cart\"></i>\n</button>"


//////////////////
// WEBPACK FOOTER
// ./src/app/invite-friends/invite-friends.component.html
// module id = ./src/app/invite-friends/invite-friends.component.html
// module chunks = main